import { ANNOTATION_ICONS } from './annotationIcons.js'

export const ANNOTATION_SYMBOLS = [
  { value: 'circle', label: 'Círculo', type: 'shape' },
  { value: 'square', label: 'Cuadrado', type: 'shape' },
  { value: 'diamond', label: 'Rombo', type: 'shape' },
  { value: 'triangle', label: 'Triángulo', type: 'shape' },
  { value: 'star', label: 'Estrella', type: 'shape' }
].concat(ANNOTATION_ICONS.map(function (icon) {
  return {
    value: icon.value,
    label: icon.label,
    type: 'icon'
  }
}))

export const DEFAULT_USER_ANNOTATION_STYLE = {
  symbol: 'circle',
  color: '#3399ff',
  size: 8,
  show_label: false
}

export const DEFAULT_GROUP_ANNOTATION_STYLE = {
  symbol: 'circle',
  color: '#f28c28',
  size: 8,
  show_label: false
}

const VALID_SYMBOLS = ANNOTATION_SYMBOLS.map(function (option) {
  return option.value
})

export function normalizeAnnotationStyle(style, fallback) {
  const defaultStyle = fallback || DEFAULT_USER_ANNOTATION_STYLE
  const rawStyle = style || {}
  const parsedSize = Number(rawStyle.size)
  const normalizedColor = typeof rawStyle.color === 'string'
    ? rawStyle.color.toLowerCase()
    : ''

  return {
    symbol: VALID_SYMBOLS.indexOf(rawStyle.symbol) !== -1
      ? rawStyle.symbol
      : defaultStyle.symbol,
    color: /^#[0-9a-f]{6}$/i.test(normalizedColor)
      ? normalizedColor
      : defaultStyle.color,
    size: Number.isFinite(parsedSize)
      ? Math.min(24, Math.max(6, Math.round(parsedSize)))
      : defaultStyle.size,
    show_label: rawStyle.show_label === true
  }
}

export function cloneAnnotationStyle(style, fallback) {
  return Object.assign({}, normalizeAnnotationStyle(style, fallback))
}
